import { useApi } from '@/api';
import { ChartSkeleton } from '@/components';
import { Flex } from '@blockanalitica/ui';
import SurplusDepositsChart from './SurplusDepositsChart';

export default function HistoricTabs() {
  const [data, error] = useApi({
    url: '/surplus/depositors/'
  });

  if (error) {
    throw error;
  }

  if (data) {
    return (
      <Flex flexDirection="column" gap="xs">
        <SurplusDepositsChart data={data} />
      </Flex>
    );
  }

  return <ChartSkeleton />;
}
